module.exports = __webpack_public_path__ + "img/motive-table.52147ff7.svg";